import styled from 'styled-components';

export const Icon = styled.div`
  display: inline-block;
  height: ${p => p.size}px;
  vertical-align: ${p => p.valign};
  width: ${p => p.size}px;

  ${p =>
    p.onClick &&
    `
    cursor: pointer;
  `}

  > svg {
    display: block;
    height: 100%;
    width: 100%;

    ${p =>
      p.shouldInheritTextColor &&
      `
      path {
        fill: currentColor;
      }
    `}
  }
`;
